// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .box-set .css-46bh2p-MuiCardContent-root:nth-child(1), .box-set .css-46bh2p-MuiCardContent-root:nth-child(2) {
    border-right: 1px solid gainsboro;

} */
.box-set .resumeTabels th,.box-set .resumeTabels td{
border: 0px solid !important;
height: 100px;
vertical-align:top;
min-width: 309px;
}
.stockReportSection .ant-tabs-content{
    height: 100%;
}
.stockReportSection .ant-tabs-content .ant-tabs-tabpane.ant-tabs-tabpane-active{
   height: 100%;
}
.no_datas p{
    margin: 0 auto;
    font-size: 25px;
    color: #108757 !important;
}
.no_datas{
    height: 100%;
    place-items: center;
    display: flex;
}

.box-set .resumeTabels th{
    padding-top: 20px;
}
.box-set .resumeTabels th,.box-set .resumeTabels td{
    border-right: 1px solid  #EDEDED !important;
    }
    .box-set .resumeTabels th:nth-last-child(1),.box-set .resumeTabels td:nth-last-child(1){
        border-right: 0px solid  #EDEDED !important;
        }
.box-set .css-46bh2p-MuiCardContent-root:nth-child(3) p:nth-child(2){
    margin-top: 64px;

}
.box-set .css-46bh2p-MuiCardContent-root{
    padding: 0 23px 0 30px;
    /* width: 300px; */
}
/* .box-set .css-46bh2p-MuiCardContent-root:nth-child(1) p:nth-child(2){
    margin-bottom: 37px;
} */
.box-set .resumeTabels th{
    background-color: transparent;

}
/* .box-set .css-46bh2p-MuiCardContent-root p:nth-child(3), .box-set .css-46bh2p-MuiCardContent-root p:nth-child(4) {
      font-size: 1.675rem;
  } */
  .resumeTabels .data-tabel {
    word-break: break-word
  }
  .box-set .card{
 border: 1px solid #EDEDED;
  }
.box-set .css-46bh2p-MuiCardContent-root p:nth-child(4){
    font-size: 1.175rem;
}
.box-set .css-46bh2p-MuiCardContent-root p:nth-child(4), .box-set .css-46bh2p-MuiCardContent-root p:nth-child(2){

    color: #979797!important;
}

.box-set .MuiTableRow-head th {
    /* width: 914px; */
    height: 76px;

    background: var(--unnamed-color-ededed) 0% 0% no-repeat padding-box;
    border: 1px solid var(--unnamed-color-ededed);
    background: #EDEDED 0% 0% no-repeat padding-box;
    border: 1px solid #EDEDED;
    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/var(--unnamed-line-spacing-22) var(--unnamed-font-family-montserrat);
letter-spacing: var(--unnamed-character-spacing-0);
color: var(--unnamed-color-646464);
text-align: left;
font: normal normal 600 16px/22px Montserrat;
letter-spacing: 0px;
color: #646464;
opacity: 1;
padding-left: 50px;
}

.box-set  .css-4dlbcy-MuiTableRow-root th:nth-child(1) {
height: 19px;
font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/29px var(--unnamed-font-family-montserrat);
color: var(--unnamed-color-373737);
text-align: left;
font: normal normal 600 16px/29px Montserrat;
letter-spacing: 0.26px;
color: #373737;
opacity: 1;

}
.box-set .stockReportSection .card {
    box-shadow: none;
}
.box-set .css-4dlbcy-MuiTableRow-root {
    height: 94px;
}
.box-set .MuiTableCell-body {
    border-bottom: 1px solid #ededed;
    text-align: center;
height: 19px;
font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-16)/29px var(--unnamed-font-family-montserrat);
color: var(--unnamed-color-373737);
text-align: left;
font: normal normal normal 16px/29px Montserrat;
letter-spacing: 0.26px;
color: #373737;
opacity: 1;
padding-left: 50px;
}

.box-set  .css-11xur9t-MuiPaper-root-MuiTableContainer-root{
    box-shadow: none;
}

.popupbox .css-1t1j96h-MuiPaper-root-MuiDialog-paper {

    padding-top: 0;
    width: 490px;
    /* height: 280px; */
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 18px #00000029;
    opacity: 1;
    max-height: unset;
}
.popupbox ul li {
    padding: 12px 10px 11px 10px;
    background: var(--unnamed-color-fafafa) 0% 0% no-repeat padding-box;
    background: #FAFAFA 0% 0% no-repeat padding-box;
    border: 1px solid #F5F5F5;
    /* width: 461px; */
    /* height: 70px; */
    margin-bottom: 16px;
    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/var(--unnamed-line-spacing-22) var(--unnamed-font-family-montserrat);
    color: var(--unnamed-color-00261a);
    text-align: left;
    font: normal normal 600 16px/22px Montserrat;
    letter-spacing: 0.26px;
    color: #00261A;
    opacity: 1;
    cursor: pointer;
}


.popupbox h2{

font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-20)/var(--unnamed-line-spacing-28) var(--unnamed-font-family-montserrat);
letter-spacing: var(--unnamed-character-spacing-0);
color: var(--unnamed-color-373737);
text-align: center;
font: normal normal bold 20px/28px Montserrat;
letter-spacing: 0px;
color: #373737;
opacity: 1;
height: 87px;
    border-bottom: 1px solid gainsboro;
    padding: 33px;
    line-height: 1;

}
.popupbox ul{
    padding: 25px;
    margin-bottom: 0;
}
.popupbox button{
    background: #ebebeb;
    padding: 2px 4px 2px 4px;
}
.popupbox ul li  svg {
    display: inline-flex;
    margin-right: 26px;
}
.popupbox ul li  svg:nth-child(2) {
    float: right;
    margin-right: 0px;
    width: 14px;
    margin-top: 10px;
}

.heading{
    margin-left: 20px;
}


.PlanifiActuel .MuiGrid-item {
    display: flex;
}

.headtitle{

    width: 168px;
    height: 31px;
    border: 1px solid var(--unnamed-color-ededed);
    background: #FFBE0040 0% 0% no-repeat padding-box;
    border: 1px solid #EDEDED;
    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);
    color: var(--unnamed-color-373737);

    font: normal normal 600 14px/29px Montserrat;
    letter-spacing: 0.22px;
    color: #373737;
    opacity: 1;
}
.PlanifiActuel  {
    margin-top: 36px;

    border: 1px solid gainsboro;
  
    background: white;
}
.Activité .tabs li {
    padding: 15px 0 15px 0;
    border: 1px solid gainsboro;
    text-align: -webkit-center;
}
.boxxs {
    margin: 22px;
   
}
.Activité, .Planifié {
    width: 15%;
    text-align: center;
}
.boxxs .claenderweekss {
    width: 70%;
}
.Activité li .Défrichage {
 
width: 77px;
height: 18px;
/* UI Properties */
font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);
color: var(--unnamed-color-373737);
text-align: left;
font: normal normal 600 14px/29px Montserrat;
letter-spacing: 0.22px;
color: #373737;
opacity: 1;
}
.Activité li:nth-child(2), .Activité li:nth-child(4), .Activité li:nth-child(1), .Activité li:nth-child(3){
    width: 168px;
    height: 100px;
    /* UI Properties */
    border: 1px solid var(--unnamed-color-ededed);
 
    border: 1px solid #EDEDED;
    opacity: 1;
}
.Activité li:nth-child(2), .Activité li:nth-child(4){
background: #10875740 0% 0% no-repeat padding-box;
}
.Activité li:nth-child(1), .Activité li:nth-child(3){
 background: #FFBE0040 0% 0% no-repeat padding-box;
}

.Activité li:nth-child(4) {
    padding-bottom: 25px;
    padding-top: 25px;
}
.Planifié .Planifiéone{
   
width: 180px;
height: 31px;
border: 1px solid var(--unnamed-color-ededed);
background: #FFBE001A 0% 0% no-repeat padding-box;
border: 1px solid #EDEDED;
font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);
color: var(--unnamed-color-373737);
text-align: left;
font: normal normal 600 14px/29px Montserrat;
letter-spacing: 0.22px;
color: #373737;
opacity: 1;
padding-left: 21px;
}

.Planifié li div{

width: 180px;
height: 50px;
/* UI Properties */
border: 1px solid var(--unnamed-color-ededed);
background: #FFBE001A 0% 0% no-repeat padding-box;
border: 1px solid #EDEDED;

padding-top: 10px;
/* UI Properties */
font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-14)/25px var(--unnamed-font-family-montserrat);
color: var(--unnamed-color-373737);
text-align: left;
font: normal normal normal 14px/25px Montserrat;
letter-spacing: 0.22px;
color: #373737;
opacity: 1;
padding-left: 21px;
}

.boxxs .css-0 {

    padding: 0;
    border-bottom: 1px solid gainsboro;
}

.boxxs .react-datepicker__month-container {
 
    padding: 0 16px 0 15px;
    width: 20%;
height: 30px;
/* UI Properties */
border: 1px solid var(--unnamed-color-ededed);
background: #FFBE000D 0% 0% no-repeat padding-box;
border: 1px solid #EDEDED;
opacity: 1;
margin-right: 10px;
}
.boxxs  .react-datepicker__header  {
    border-bottom: none;
    border: 1px solid var(--unnamed-color-ededed);
background: #FFBE000D 0% 0% no-repeat padding-box;
padding-top: 1px;
}
.boxxs .react-datepicker {
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 0!important;
}


.boxxs .react-datepicker button {
   
 
    top: 2px;
    padding: 10px 17px 15px 12px;
    /* width: 60px; */
    border-radius: 50%;
    background: #108757;
 
    width: 18px;
    height: 18px;
    background: var(--unnamed-color-979797) 0% 0% no-repeat padding-box;
    background: #979797 0% 0% no-repeat padding-box;
    opacity: 1;
}
.boxxs .react-datepicker .react-datepicker__navigation--previous span{
    left: 12px!important;
    top: 7px!important;
}

.boxxs .react-datepicker .react-datepicker__navigation--next span{
    right: 12px!important;
    top: 7px!important;
}
::-webkit-scrollbar-corner { background: rgba(0,0,0,0.5); 
    width: 5px;
}
::-webkit-scrollbar-thumb {
    width: 5px;
    background-color: red;
  }

.stockReportSection  .ant-tabs-nav {
    height: 80vh;
    /* overflow: auto; */
}

.boxxs .name ul {
    display: flex;
    margin-bottom: 0;
}
/* .boxxs .name div {
    width: 22%;
} */
.boxxs .name ul:nth-child(1) li {
    padding:9px;
}
.boxxs .name li{
 
    border: 1px solid gainsboro;
    width: 39px;
height: 50px;
/* UI Properties */
border: 1px solid var(--unnamed-color-ededed);
background: #FFBE000D 0% 0% no-repeat padding-box;
border: 1px solid #EDEDED;
text-align: center;
}
.boxxs .tabs li{
    width: 100%;
}
.headtitle{
    width: 100%;
}
.boxxs .name {
   
}
.onebox {
    display: flex;
    width: 100%;
}
/* .boxxs .name:nth-child(1) {
    margin-right: 11px;
    width: 22.8%;
} */


.boxxs .name {
 
    width: 100%;
} 
.boxxs .react-datepicker__current-month {

    font-size:13px;
}
.stockReportSection .ant-tabs-left > .ant-tabs-nav .ant-tabs-tab{
    margin: 0px 0 0 0 !important;
    border: 1px solid #EDEDED;
}
.resumeTabels .qnt-data{
    color: #373737 !important;
    font-size: 30px !important;
}
.items-dtails h4.qnt-data{
    color: #373737 !important;
    margin-right: 10px;
    font-size: 30px !important;
}
.resumeTabels p.qnt-data{
    color: #373737 !important;
}
.cfa-data{
    color: #979797 !important;
    font-size: 20px !important;
}
.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1{
    margin-bottom: 20px;
}
.box-set tr th{
    color: #373737;
    font-size: 16px !important;
    font-weight: 600 !important;
}
.box-set tr td{
    color: #373737 !important;
    font-size: 16px !important;
}
.ant-tabs-dropdown.ant-tabs-dropdown-placement-topLeft .ant-tabs-dropdown-menu-item {
  text-align: center;
}
.ant-tabs-dropdown.ant-tabs-dropdown-placement-topLeft .ant-tabs-dropdown-menu-item svg{
    margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/Report/style.css"],"names":[],"mappings":"AAAA;;;GAGG;AACH;AACA,4BAA4B;AAC5B,aAAa;AACb,kBAAkB;AAClB,gBAAgB;AAChB;AACA;IACI,YAAY;AAChB;AACA;GACG,YAAY;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,2CAA2C;IAC3C;IACA;QACI,2CAA2C;QAC3C;AACR;IACI,gBAAgB;;AAEpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;;GAEG;AACH;IACI,6BAA6B;;AAEjC;AACA;;KAEK;EACH;IACE;EACF;EACA;CACD,yBAAyB;EACxB;AACF;IACI,mBAAmB;AACvB;AACA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,mEAAmE;IACnE,6CAA6C;IAC7C,+CAA+C;IAC/C,yBAAyB;IAEzB,6KAA6K;AACjL,kDAAkD;AAClD,kCAAkC;AAClC,gBAAgB;AAChB,4CAA4C;AAC5C,mBAAmB;AACnB,cAAc;AACd,UAAU;AACV,kBAAkB;AAClB;;AAEA;AACA,YAAY;AACZ,mJAAmJ;AACnJ,kCAAkC;AAClC,gBAAgB;AAChB,4CAA4C;AAC5C,sBAAsB;AACtB,cAAc;AACd,UAAU;;AAEV;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB,YAAY;AACZ,sJAAsJ;AACtJ,kCAAkC;AAClC,gBAAgB;AAChB,+CAA+C;AAC/C,sBAAsB;AACtB,cAAc;AACd,UAAU;AACV,kBAAkB;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,mEAAmE;IACnE,+CAA+C;IAC/C,kCAAkC;IAClC,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,mEAAmE;IACnE,+CAA+C;IAC/C,yBAAyB;IAEzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,6KAA6K;IAC7K,kCAAkC;IAClC,gBAAgB;IAChB,4CAA4C;IAC5C,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;;AAGA;;AAEA,8KAA8K;AAC9K,kDAAkD;AAClD,kCAAkC;AAClC,kBAAkB;AAClB,6CAA6C;AAC7C,mBAAmB;AACnB,cAAc;AACd,UAAU;AACV,YAAY;IACR,kCAAkC;IAClC,aAAa;IACb,cAAc;;AAElB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,6CAA6C;IAC7C,iDAAiD;IACjD,yBAAyB;IACzB,mJAAmJ;IACnJ,kCAAkC;;IAElC,4CAA4C;IAC5C,sBAAsB;IACtB,cAAc;IACd,UAAU;AACd;AACA;IACI,gBAAgB;;IAEhB,2BAA2B;;IAE3B,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,YAAY;;AAEhB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;;AAEA,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,mJAAmJ;AACnJ,kCAAkC;AAClC,gBAAgB;AAChB,4CAA4C;AAC5C,sBAAsB;AACtB,cAAc;AACd,UAAU;AACV;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6CAA6C;;IAE7C,yBAAyB;IACzB,UAAU;AACd;AACA;AACA,iDAAiD;AACjD;AACA;CACC,iDAAiD;AAClD;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;AACA;;AAEA,YAAY;AACZ,YAAY;AACZ,6CAA6C;AAC7C,iDAAiD;AACjD,yBAAyB;AACzB,mJAAmJ;AACnJ,kCAAkC;AAClC,gBAAgB;AAChB,4CAA4C;AAC5C,sBAAsB;AACtB,cAAc;AACd,UAAU;AACV,kBAAkB;AAClB;;AAEA;;AAEA,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,6CAA6C;AAC7C,iDAAiD;AACjD,yBAAyB;;AAEzB,iBAAiB;AACjB,kBAAkB;AAClB,sJAAsJ;AACtJ,kCAAkC;AAClC,gBAAgB;AAChB,+CAA+C;AAC/C,sBAAsB;AACtB,cAAc;AACd,UAAU;AACV,kBAAkB;AAClB;;AAEA;;IAEI,UAAU;IACV,kCAAkC;AACtC;;AAEA;;IAEI,sBAAsB;IACtB,UAAU;AACd,YAAY;AACZ,kBAAkB;AAClB,6CAA6C;AAC7C,iDAAiD;AACjD,yBAAyB;AACzB,UAAU;AACV,kBAAkB;AAClB;AACA;IACI,mBAAmB;IACnB,6CAA6C;AACjD,iDAAiD;AACjD,gBAAgB;AAChB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;;;AAGA;;;IAGI,QAAQ;IACR,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,mEAAmE;IACnE,+CAA+C;IAC/C,UAAU;AACd;AACA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA,6BAA6B,2BAA2B;IACpD,UAAU;AACd;AACA;IACI,UAAU;IACV,qBAAqB;EACvB;;AAEF;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;;GAEG;AACH;IACI,WAAW;AACf;AACA;;IAEI,2BAA2B;IAC3B,WAAW;AACf,YAAY;AACZ,kBAAkB;AAClB,6CAA6C;AAC7C,iDAAiD;AACjD,yBAAyB;AACzB,kBAAkB;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;;AAEA;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;;;GAGG;;;AAGH;;IAEI,WAAW;AACf;AACA;;IAEI,cAAc;AAClB;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;IACI,cAAc;AAClB","sourcesContent":["/* .box-set .css-46bh2p-MuiCardContent-root:nth-child(1), .box-set .css-46bh2p-MuiCardContent-root:nth-child(2) {\n    border-right: 1px solid gainsboro;\n\n} */\n.box-set .resumeTabels th,.box-set .resumeTabels td{\nborder: 0px solid !important;\nheight: 100px;\nvertical-align:top;\nmin-width: 309px;\n}\n.stockReportSection .ant-tabs-content{\n    height: 100%;\n}\n.stockReportSection .ant-tabs-content .ant-tabs-tabpane.ant-tabs-tabpane-active{\n   height: 100%;\n}\n.no_datas p{\n    margin: 0 auto;\n    font-size: 25px;\n    color: #108757 !important;\n}\n.no_datas{\n    height: 100%;\n    place-items: center;\n    display: flex;\n}\n\n.box-set .resumeTabels th{\n    padding-top: 20px;\n}\n.box-set .resumeTabels th,.box-set .resumeTabels td{\n    border-right: 1px solid  #EDEDED !important;\n    }\n    .box-set .resumeTabels th:nth-last-child(1),.box-set .resumeTabels td:nth-last-child(1){\n        border-right: 0px solid  #EDEDED !important;\n        }\n.box-set .css-46bh2p-MuiCardContent-root:nth-child(3) p:nth-child(2){\n    margin-top: 64px;\n\n}\n.box-set .css-46bh2p-MuiCardContent-root{\n    padding: 0 23px 0 30px;\n    /* width: 300px; */\n}\n/* .box-set .css-46bh2p-MuiCardContent-root:nth-child(1) p:nth-child(2){\n    margin-bottom: 37px;\n} */\n.box-set .resumeTabels th{\n    background-color: transparent;\n\n}\n/* .box-set .css-46bh2p-MuiCardContent-root p:nth-child(3), .box-set .css-46bh2p-MuiCardContent-root p:nth-child(4) {\n      font-size: 1.675rem;\n  } */\n  .resumeTabels .data-tabel {\n    word-break: break-word\n  }\n  .box-set .card{\n border: 1px solid #EDEDED;\n  }\n.box-set .css-46bh2p-MuiCardContent-root p:nth-child(4){\n    font-size: 1.175rem;\n}\n.box-set .css-46bh2p-MuiCardContent-root p:nth-child(4), .box-set .css-46bh2p-MuiCardContent-root p:nth-child(2){\n\n    color: #979797!important;\n}\n\n.box-set .MuiTableRow-head th {\n    /* width: 914px; */\n    height: 76px;\n\n    background: var(--unnamed-color-ededed) 0% 0% no-repeat padding-box;\n    border: 1px solid var(--unnamed-color-ededed);\n    background: #EDEDED 0% 0% no-repeat padding-box;\n    border: 1px solid #EDEDED;\n    opacity: 1;\n    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/var(--unnamed-line-spacing-22) var(--unnamed-font-family-montserrat);\nletter-spacing: var(--unnamed-character-spacing-0);\ncolor: var(--unnamed-color-646464);\ntext-align: left;\nfont: normal normal 600 16px/22px Montserrat;\nletter-spacing: 0px;\ncolor: #646464;\nopacity: 1;\npadding-left: 50px;\n}\n\n.box-set  .css-4dlbcy-MuiTableRow-root th:nth-child(1) {\nheight: 19px;\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/29px var(--unnamed-font-family-montserrat);\ncolor: var(--unnamed-color-373737);\ntext-align: left;\nfont: normal normal 600 16px/29px Montserrat;\nletter-spacing: 0.26px;\ncolor: #373737;\nopacity: 1;\n\n}\n.box-set .stockReportSection .card {\n    box-shadow: none;\n}\n.box-set .css-4dlbcy-MuiTableRow-root {\n    height: 94px;\n}\n.box-set .MuiTableCell-body {\n    border-bottom: 1px solid #ededed;\n    text-align: center;\nheight: 19px;\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-16)/29px var(--unnamed-font-family-montserrat);\ncolor: var(--unnamed-color-373737);\ntext-align: left;\nfont: normal normal normal 16px/29px Montserrat;\nletter-spacing: 0.26px;\ncolor: #373737;\nopacity: 1;\npadding-left: 50px;\n}\n\n.box-set  .css-11xur9t-MuiPaper-root-MuiTableContainer-root{\n    box-shadow: none;\n}\n\n.popupbox .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n\n    padding-top: 0;\n    width: 490px;\n    /* height: 280px; */\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 3px 18px #00000029;\n    opacity: 1;\n    max-height: unset;\n}\n.popupbox ul li {\n    padding: 12px 10px 11px 10px;\n    background: var(--unnamed-color-fafafa) 0% 0% no-repeat padding-box;\n    background: #FAFAFA 0% 0% no-repeat padding-box;\n    border: 1px solid #F5F5F5;\n    opacity: 1;\n    /* width: 461px; */\n    /* height: 70px; */\n    margin-bottom: 16px;\n    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-16)/var(--unnamed-line-spacing-22) var(--unnamed-font-family-montserrat);\n    color: var(--unnamed-color-00261a);\n    text-align: left;\n    font: normal normal 600 16px/22px Montserrat;\n    letter-spacing: 0.26px;\n    color: #00261A;\n    opacity: 1;\n    cursor: pointer;\n}\n\n\n.popupbox h2{\n\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-20)/var(--unnamed-line-spacing-28) var(--unnamed-font-family-montserrat);\nletter-spacing: var(--unnamed-character-spacing-0);\ncolor: var(--unnamed-color-373737);\ntext-align: center;\nfont: normal normal bold 20px/28px Montserrat;\nletter-spacing: 0px;\ncolor: #373737;\nopacity: 1;\nheight: 87px;\n    border-bottom: 1px solid gainsboro;\n    padding: 33px;\n    line-height: 1;\n\n}\n.popupbox ul{\n    padding: 25px;\n    margin-bottom: 0;\n}\n.popupbox button{\n    background: #ebebeb;\n    padding: 2px 4px 2px 4px;\n}\n.popupbox ul li  svg {\n    display: inline-flex;\n    margin-right: 26px;\n}\n.popupbox ul li  svg:nth-child(2) {\n    float: right;\n    margin-right: 0px;\n    width: 14px;\n    margin-top: 10px;\n}\n\n.heading{\n    margin-left: 20px;\n}\n\n\n.PlanifiActuel .MuiGrid-item {\n    display: flex;\n}\n\n.headtitle{\n\n    width: 168px;\n    height: 31px;\n    border: 1px solid var(--unnamed-color-ededed);\n    background: #FFBE0040 0% 0% no-repeat padding-box;\n    border: 1px solid #EDEDED;\n    font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);\n    color: var(--unnamed-color-373737);\n\n    font: normal normal 600 14px/29px Montserrat;\n    letter-spacing: 0.22px;\n    color: #373737;\n    opacity: 1;\n}\n.PlanifiActuel  {\n    margin-top: 36px;\n\n    border: 1px solid gainsboro;\n  \n    background: white;\n}\n.Activité .tabs li {\n    padding: 15px 0 15px 0;\n    border: 1px solid gainsboro;\n    text-align: -webkit-center;\n}\n.boxxs {\n    margin: 22px;\n   \n}\n.Activité, .Planifié {\n    width: 15%;\n    text-align: center;\n}\n.boxxs .claenderweekss {\n    width: 70%;\n}\n.Activité li .Défrichage {\n \nwidth: 77px;\nheight: 18px;\n/* UI Properties */\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);\ncolor: var(--unnamed-color-373737);\ntext-align: left;\nfont: normal normal 600 14px/29px Montserrat;\nletter-spacing: 0.22px;\ncolor: #373737;\nopacity: 1;\n}\n.Activité li:nth-child(2), .Activité li:nth-child(4), .Activité li:nth-child(1), .Activité li:nth-child(3){\n    width: 168px;\n    height: 100px;\n    /* UI Properties */\n    border: 1px solid var(--unnamed-color-ededed);\n \n    border: 1px solid #EDEDED;\n    opacity: 1;\n}\n.Activité li:nth-child(2), .Activité li:nth-child(4){\nbackground: #10875740 0% 0% no-repeat padding-box;\n}\n.Activité li:nth-child(1), .Activité li:nth-child(3){\n background: #FFBE0040 0% 0% no-repeat padding-box;\n}\n\n.Activité li:nth-child(4) {\n    padding-bottom: 25px;\n    padding-top: 25px;\n}\n.Planifié .Planifiéone{\n   \nwidth: 180px;\nheight: 31px;\nborder: 1px solid var(--unnamed-color-ededed);\nbackground: #FFBE001A 0% 0% no-repeat padding-box;\nborder: 1px solid #EDEDED;\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600) var(--unnamed-font-size-14)/29px var(--unnamed-font-family-montserrat);\ncolor: var(--unnamed-color-373737);\ntext-align: left;\nfont: normal normal 600 14px/29px Montserrat;\nletter-spacing: 0.22px;\ncolor: #373737;\nopacity: 1;\npadding-left: 21px;\n}\n\n.Planifié li div{\n\nwidth: 180px;\nheight: 50px;\n/* UI Properties */\nborder: 1px solid var(--unnamed-color-ededed);\nbackground: #FFBE001A 0% 0% no-repeat padding-box;\nborder: 1px solid #EDEDED;\n\npadding-top: 10px;\n/* UI Properties */\nfont: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-14)/25px var(--unnamed-font-family-montserrat);\ncolor: var(--unnamed-color-373737);\ntext-align: left;\nfont: normal normal normal 14px/25px Montserrat;\nletter-spacing: 0.22px;\ncolor: #373737;\nopacity: 1;\npadding-left: 21px;\n}\n\n.boxxs .css-0 {\n\n    padding: 0;\n    border-bottom: 1px solid gainsboro;\n}\n\n.boxxs .react-datepicker__month-container {\n \n    padding: 0 16px 0 15px;\n    width: 20%;\nheight: 30px;\n/* UI Properties */\nborder: 1px solid var(--unnamed-color-ededed);\nbackground: #FFBE000D 0% 0% no-repeat padding-box;\nborder: 1px solid #EDEDED;\nopacity: 1;\nmargin-right: 10px;\n}\n.boxxs  .react-datepicker__header  {\n    border-bottom: none;\n    border: 1px solid var(--unnamed-color-ededed);\nbackground: #FFBE000D 0% 0% no-repeat padding-box;\npadding-top: 1px;\n}\n.boxxs .react-datepicker {\n    padding-left: 0px;\n    padding-right: 0px;\n    padding-bottom: 0!important;\n}\n\n\n.boxxs .react-datepicker button {\n   \n \n    top: 2px;\n    padding: 10px 17px 15px 12px;\n    /* width: 60px; */\n    border-radius: 50%;\n    background: #108757;\n \n    width: 18px;\n    height: 18px;\n    background: var(--unnamed-color-979797) 0% 0% no-repeat padding-box;\n    background: #979797 0% 0% no-repeat padding-box;\n    opacity: 1;\n}\n.boxxs .react-datepicker .react-datepicker__navigation--previous span{\n    left: 12px!important;\n    top: 7px!important;\n}\n\n.boxxs .react-datepicker .react-datepicker__navigation--next span{\n    right: 12px!important;\n    top: 7px!important;\n}\n::-webkit-scrollbar-corner { background: rgba(0,0,0,0.5); \n    width: 5px;\n}\n::-webkit-scrollbar-thumb {\n    width: 5px;\n    background-color: red;\n  }\n\n.stockReportSection  .ant-tabs-nav {\n    height: 80vh;\n    /* overflow: auto; */\n}\n\n.boxxs .name ul {\n    display: flex;\n    margin-bottom: 0;\n}\n/* .boxxs .name div {\n    width: 22%;\n} */\n.boxxs .name ul:nth-child(1) li {\n    padding:9px;\n}\n.boxxs .name li{\n \n    border: 1px solid gainsboro;\n    width: 39px;\nheight: 50px;\n/* UI Properties */\nborder: 1px solid var(--unnamed-color-ededed);\nbackground: #FFBE000D 0% 0% no-repeat padding-box;\nborder: 1px solid #EDEDED;\ntext-align: center;\n}\n.boxxs .tabs li{\n    width: 100%;\n}\n.headtitle{\n    width: 100%;\n}\n.boxxs .name {\n   \n}\n.onebox {\n    display: flex;\n    width: 100%;\n}\n/* .boxxs .name:nth-child(1) {\n    margin-right: 11px;\n    width: 22.8%;\n} */\n\n\n.boxxs .name {\n \n    width: 100%;\n} \n.boxxs .react-datepicker__current-month {\n\n    font-size:13px;\n}\n.stockReportSection .ant-tabs-left > .ant-tabs-nav .ant-tabs-tab{\n    margin: 0px 0 0 0 !important;\n    border: 1px solid #EDEDED;\n}\n.resumeTabels .qnt-data{\n    color: #373737 !important;\n    font-size: 30px !important;\n}\n.items-dtails h4.qnt-data{\n    color: #373737 !important;\n    margin-right: 10px;\n    font-size: 30px !important;\n}\n.resumeTabels p.qnt-data{\n    color: #373737 !important;\n}\n.cfa-data{\n    color: #979797 !important;\n    font-size: 20px !important;\n}\n.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1{\n    margin-bottom: 20px;\n}\n.box-set tr th{\n    color: #373737;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n}\n.box-set tr td{\n    color: #373737 !important;\n    font-size: 16px !important;\n}\n.ant-tabs-dropdown.ant-tabs-dropdown-placement-topLeft .ant-tabs-dropdown-menu-item {\n  text-align: center;\n}\n.ant-tabs-dropdown.ant-tabs-dropdown-placement-topLeft .ant-tabs-dropdown-menu-item svg{\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
